import { render, staticRenderFns } from "./IntegrationForm.vue?vue&type=template&id=58e39b9b&scoped=true"
import script from "./IntegrationForm.vue?vue&type=script&lang=js"
export * from "./IntegrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e39b9b",
  null
  
)

export default component.exports